import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CardInfos, CpxHandleServiceAbstract } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { DmpServiceAbstract } from 'src/app/services/dmp/dmp-service.abstract';
import { HeartbeatService } from 'src/app/services/heartbeat/heartbeat.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { isAllowedExternalUrl } from 'src/app/utils/safe-url';

@Component({
  selector: 'frg-header',
  templateUrl: './header.fragment.html',
  styleUrls: ['./header.fragment.scss']
})
export class HeaderFragment implements OnInit, OnDestroy {

  @Input() public title: string;
  @Input() public accountName: string;
  @Input() public delegationName: string;
  @Input() public isBack: boolean = false;
  @Input() public backPage: string = "home"
  @Input() public backCallBack: () => Promise<boolean>;
  @Input() public delegations: any[];

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  private _cardInfosSub: Subscription;
  public cardInfos: CardInfos | undefined = undefined;

  constructor(
    private _router: Router,
    private _modalService: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _authService: AuthService,
    private _loginService: LoginService,
    private _heartbeatService: HeartbeatService,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _dmpSrv: DmpServiceAbstract,
  ) { }

  ngOnInit(): void {
    this._cardInfosSub = this._cpxHandleSrv.cpxCardInfos.subscribe((cardInfos: CardInfos) => {
      this.cardInfos = cardInfos;
    });
  }

  ngOnDestroy() {
    if (this._cardInfosSub) {
      this._cardInfosSub.unsubscribe();
    }
  }

  public routeTo(routeInfo: string): void {
    this._router.navigateByUrl("/user/" + routeInfo);
  }

  public routeToSettings(): void {
    if (!this.delegationName) {
      this._router.navigateByUrl("/user/settings");
    }
  }

  public async routeToDmpTdb(): Promise<void> {
    // On récupère les informations de l'espace Web PS
    const urls = await this._dmpSrv.hl_getwebpsdmpurls(this._viewContainerRef, { s_ins: '255069999999934', s_insType: 'N' });

    if (urls && isAllowedExternalUrl(urls.Urls[0])) {
      window.open(urls.Urls[0]);
    } else {
      this._modalService.openAlert(
        this._viewContainerRef,
        'Pas de lien',
        'Aucune URL n\'est disponible'
      );
    }
  }

  public openMenu(): void {
    if (!this.delegationName || this.delegations.length > 0) {
      this.trigger.openMenu();
    }
  }

  public async quitDelegation(standalone: boolean) {
    let loadingModal;
    if (standalone) {
      this._heartbeatService.inHearbeat = true;
      loadingModal = this._modalService.openLoading(this._viewContainerRef);
    }
    try {
      const profil = await this._authService.quitDelegation();
      this._loginService.removeCurrentDelegataireProfil();
      this._loginService.removeCurrentDelegataireUser();
      this._loginService.saveCurrentProfil(profil);
      this._loginService.saveCurrentUser(profil.utilisateur);
    } catch (e) {
      console.error(e);
    }
    if (standalone) {
      this._heartbeatService.inHearbeat = false;
      this._modalService.close(loadingModal);
      window.location.href = "/user/home";
    }
  }

  public async selectDelegation(delegationId) {
    this._heartbeatService.inHearbeat = true;
    const loadingModal = this._modalService.openLoading(this._viewContainerRef);
    try {
      if (this.delegationName) {
        await this.quitDelegation(false);
      }
      const profil = await this._authService.selectDelegation(delegationId);
      this._loginService.saveCurrentDelegataireProfil(this._loginService.getCurrentProfil());
      this._loginService.saveCurrentDelegataireUser(this._loginService.getCurrentUser());
      this._loginService.saveCurrentProfil(profil);
      this._loginService.saveCurrentUser(profil.utilisateur);
      this._modalService.close(loadingModal);
      window.location.href = "/user/home";
    } catch (e) {
      throw e;
    } finally {
      this._heartbeatService.inHearbeat = false;
      this._modalService.close(loadingModal);
    }
  }

  public async backToPage() {
    if (this.backCallBack) {
      if (await this.backCallBack()) {
        this._router.navigateByUrl('/user/' + this.backPage);
      }
    } else {
      this._router.navigateByUrl('/user/' + this.backPage);
    }
  }
}
